import { useEffect, useState } from 'react';
import { Modal, Box } from '@mui/material';
import strings from '../../strings/strings.json'


const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: '0 1px 60px 0 rgba(155, 181, 190, 0.2)',
    borderRadius: '14px',
    p: 4,
};

interface Props {
    data: any,
    openModal: boolean,
    onCloseModal: () => void,
    confirmClicked: (data:any) => void
}

export default function ConfirmModal(props: Props) {

    const [openModal, setOpenModal] = useState(false)

    const handleCloseModal = () => {
        setOpenModal(false);
        props.onCloseModal()
    }

    return (
        <Modal
            open={props.openModal}
            onClose={handleCloseModal}>
            <Box sx={style}>
                <div className='flex justify-center flex-col items-center'>
                    <div className='text-2xl font-bold'>{strings.public_sure}</div>
                    <div className='text-base mt-2 font-medium'>{props.data}</div>
                    <div className='flex justify-between pt-5 px-6 mt-5 border-t border-t-gray-100 w-full'>
                        <button className='text-white w-28 rounded-full px-8 py-2 primary_bg_color text-xs' onClick={() => props.confirmClicked(props.data)}>{strings.public_confirm}</button>
                        <button className='rounded-full w-28 border border-black px-8 py-2 text-xs' onClick={() => props.onCloseModal()}> {strings.public_cancel}</button>
                    </div>
                </div>
            </Box>
        </Modal>
    )
}
